<template>
  <v-app
    id="inspire"
    class="primary-color"
  >
    <v-content>
      <v-layout
        align-center
        justify-center
        class="login-box spacing-playground pa-12"
      >
        <v-row
          xs12
          sm12
          md4
          justify="space-around"
        >
          <v-card
            class="login-card primary-color"
            width="100%"
            max-width="400px"
          >
            <v-row
              align="center"
              justify="center"
            />
            <v-toolbar
              color="toolbarBase"
              dark
              flat
            >
              <v-toolbar-title>Login</v-toolbar-title>
              <v-spacer />
              <v-tooltip right>
                <template />
              </v-tooltip>
            </v-toolbar>
            <v-card-actions>
              <v-spacer />
              <v-btn
                @click="signin"
                tile
                block
                type="submit"
                class="blue-box white-text"
              ><v-img
                contain
                max-height="20px"
                max-width="40px"
                src="@/assets/img/microsoft.png"
              />Entrar com Microsoft</v-btn>
            </v-card-actions>
          </v-card>
        </v-row>
      </v-layout>
    </v-content>
  </v-app>
</template>

<script>
import Vue from 'vue';
import { MsalPlugin } from 'msal-vue';

Vue.use(MsalPlugin, {
  auth: {
    clientId: process.env.VUE_APP_MSAL_APPID,
    authority: process.env.VUE_APP_MSAL_AUTHORITY,
    redirectUri: process.env.https://eleicao.prodam.sp.gov.br/login
  },
  cache: {
    cacheLocation: 'localStorage'
  }
});

export default {
  name: 'Login',
  components: {},
  data: () => ({}),
  computed: {},
  mounted() {},
  methods: {
    async signin() {
      const result = await this.$msal.loginPopup();
      if (this.$msal.isAuthenticated()) {
        this.$store
          .dispatch('login/loginMSAL', {
            result: result,
            election_id: this.$store.state.election.id
          })
          .then(() => {
            if (
              this.$store.state.login.accessValid &&
              this.$store.state.login.hasVoted
            ) {
              this.$router.push({ name: 'Vote' });
            } else if (this.$store.state.login.accessValid) {
              if (this.$store.state.election.Mosaico) {
                this.$router.push({ name: 'MosaicUrn' });
              } else {
                this.$router.push({ name: 'Urna' });
              }
            } else {
              alert('acesso não permitido');
            }
          })
          .catch(e => {
            alert(e);
          });
      }
    }
  }
};
</script>
